import { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { CenterBox, CenterGrid, TitleDiv, OnsiteProgress } from "../../customelements/CustomInput";
import { HttpPostData, JumpPage, FormatNumber, NumberFormatType } from "../../common/Util";
import { LoginStateConext } from "../../context/AuthContext";
import { OnsitePaypalButton, PaypalEvents } from "../../components/PaypalButton";
import { CreateOrderActions, CreateOrderData, OnApproveActions, OnApproveData, OnCancelledActions } from "@paypal/paypal-js";
import { BuyProductParam, ToPaymentConfirm, PaymentPageType, ResponseParamBase } from "../../common/Types";
import { TitleParamContext } from "../../context/TitleContext";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

type ResponseParam = ResponseParamBase & {
    list: PurchaseHistoryRow[],
}

export type PurchaseHistoryRow = {
    purchaseHistoryId: string,
}

export type PageParam = {
    list: PurchaseHistoryRow[],
}

export const PaymentConfirm = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const loginState = useContext(LoginStateConext);
    const titleContext = useContext(TitleParamContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const pageParam = location.state as ToPaymentConfirm;
    const [paypalEvents, setPaypalEvents] = useState<PaypalEvents>({ onCreateOrder: onCreateOrder, onApprove: onApprove, onCancel: onCancel, onError: onError });
    
    //const [dataList, setDataList] = useState<LicenseDatas>({ userLicenses: [], totalIncludeTaxPrice: 0, totalNonTaxPrice: 0, totalTaxPrice: 0 });
    //let dataList: LisenceDatas = { userLicenses: [], totalIncludeTaxPrice: 0, totalNonTaxPrice: 0, totalTaxPrice: 0 };

    useEffect(() => {

        (async () => {
            /*await HttpPostData<ResponseParam>("/License/GetBuyNewLicenseData", [pageParam])
                .then((response) => {
                    console.log("Response", response.data);
                    setDataList(response.data.data);
                    return response.data.data;
                })
                .then((tt) => {
                    return tt;
                })
                .catch(e => {
                    return { userLicenses: [], totalIncludeTaxPrice: 0, totalNonTaxPrice: 0, totalTaxPrice: 0 }
                });*/
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "購入確認", secondSubTitle: "" });
            setPaypalEvents({ onCreateOrder: onCreateOrder, onApprove: onApprove, onCancel: onCancel, onError: onError });
        })()
    }, []);

    function onCreateOrder(data: CreateOrderData, actions: CreateOrderActions): Promise<string> {
        return actions.order.create({
            purchase_units: [
                {
                    amount: {
                        value: pageParam.purchaseParam.totalIncludeTaxPrice.toString(),
                    },
                    description: pageParam.productParam.productName,
                }
            ]
        });
    }

    async function onApprove(data: OnApproveData, actions: OnApproveActions): Promise<void> {
        return actions.order?.capture().then(async (details) => {
            await HttpPostData("/License/CommitNewLicense", {
                userLicenses: pageParam.purchaseParam.userLicenses.map((field, index) => {

                    return {
                        ProductMasterId: field.productId,
                        PaymentContents: details.id,
                        Quantity: field.quantity,
                        NonTaxPrice: field.totalNonTaxPrice,
                        TaxPrice: field.totalTaxPrice,
                        IncludeTaxPrice: field.totalIncludeTaxPrice,
                        Licensekey: field.licenseKey,
                    }
                }),
                Email: loginState.loginInfo.email,
                PostCode: pageParam.productParam.postCode,
                PhoneNumber: pageParam.productParam.phoneNumber,
                Addreess: pageParam.productParam.address,
                CustomerName: pageParam.productParam.customerName,
                Biko: pageParam.productParam.biko,
                DeliverySpan: pageParam.deliverySpan,
                DeliveryPrice: 0,
            }, null)
                .then(response => {
                })
                .catch(e => {
                    console.log(e);
                });
            const name = details.payer.name?.given_name;
        });
    }

    function onCancel(data: Record<string, unknown>, actions: OnCancelledActions): void {

    }

    function onError(err: Record<string, unknown>): void {

    }

    return (
        <>
            <section className={market.marketArea}>
                <div></div>
                <div className={market.marketAreaInner}>
                    {pageParam.productParam.isDelivery ?
                        <CenterBox>
                            <div className={base.messageFont}>
                            下記内容をご確認のうえ、よろしければ[ PayPal ] ボタンをクリックし、<br />
                                PayPalより支払い手続きを行ってください。お支払い後、{pageParam.deliverySpan}日前後で発送いたします。
                            </div>
                        </CenterBox>
                        :
                        <CenterBox>
                            <div className={base.messageFont}>
                            下記内容をご確認のうえ、よろしければ [ PayPal ] ボタンをクリックし、<br />
                                PayPalより支払い手続きを行ってください。
                            </div>
                        </CenterBox>
                    }

                    {
                        pageParam.productParam.paymentPageType == PaymentPageType.New && <NewProductTable productParam={pageParam.productParam} purchaseParam={pageParam.purchaseParam} deliverySpan={pageParam.deliverySpan} test={pageParam.test} />
                    }
                    {
                        pageParam.productParam.paymentPageType == PaymentPageType.Continue && <ContinueProductTable productParam={pageParam.productParam} purchaseParam={pageParam.purchaseParam} deliverySpan={pageParam.deliverySpan} test={pageParam.test} />
                    }
                    {
                        pageParam.productParam.paymentPageType == PaymentPageType.Pccase && <PcCaseTable productParam={pageParam.productParam} purchaseParam={pageParam.purchaseParam} deliverySpan={pageParam.deliverySpan} test={pageParam.test} />
                    }

                    <div className={market.importantNote}>購入手続きは完了していません。</div>

                    <div className={base.errorMessage}></div>

                    <div className={market.marketFooterArea} style={{}}>
                        <button className={market.marketBackButton} onClick={(e) => { navigate(-1); }}>戻る</button>
                        {isLoading ?
                            <CenterBox><OnsiteProgress /></CenterBox>
                            :
                            <OnsitePaypalButton
                                onCreateOrder=
                                {
                                    (data, actions) => {
                                        return actions.order.create({
                                            application_context: {
                                                "shipping_preference": "NO_SHIPPING"
                                            },
                                            purchase_units: [
                                                {
                                                    items: [
                                                        {
                                                            name: pageParam.productParam.productName,
                                                            unit_amount: { value: pageParam.productParam.nonTaxPrice.toString(), currency_code: "JPY" },
                                                            quantity: pageParam.purchaseParam.userLicenses.map((field, index) => { return field.quantity }).reduce((prev, current) => { return prev + current }, 0).toString(),
                                                            tax: { value: pageParam.productParam.taxPrice.toString(), currency_code: "JPY" }
                                                        }
                                                    ],
                                                    /*items: pageParam.purchaseParam.userLicenses.map((field, index) => {
                                                        return {
                                                            name: index.toString(),
                                                            unit_amount: { value: field.totalNonTaxPrice, currency_code: "JPY" },
                                                            quantity: field.quantity,
                                                            tax: { value: field.taxPrice, currency_code: "JPY" }
                                                        }
                                                    }),*/
                                                    amount: {
                                                        breakdown: {
                                                            item_total: { value: pageParam.purchaseParam.totalNonTaxPrice.toString(), currency_code: "JPY" },
                                                            tax_total: { value: pageParam.purchaseParam.totalTaxPrice.toString(), currency_code: "JPY" },
                                                        },
                                                        value: pageParam.purchaseParam.totalIncludeTaxPrice.toString(),
                                                    },
                                                    
                                                    description: pageParam.productParam.productName,
                                                },
                                            ]
                                        });
                                    }
                                }
                                onApprove={async (data, actions) => {
                                    return actions.order?.capture().then((details) => {
                                        setErrorMessage("");
                                        const c = details.purchase_units[0].payments?.captures?.at(0);
                                        
                                        if (c === undefined) {

                                        }
                                        const id: string = (c!.id as string)
                                        const params = {
                                            UserLicenses: pageParam.purchaseParam.userLicenses.map((field, index) => {
                                                return {
                                                    UserLicenseId: field.userLicenseId,
                                                    ProductMasterId: field.productId,                                                    
                                                    //PaymentContents: details.id,
                                                    PaymentContents: id,
                                                    Quantity: field.quantity,
                                                    NonTaxPrice: field.totalNonTaxPrice,
                                                    TaxPrice: field.totalTaxPrice,
                                                    IncludeTaxPrice: field.totalIncludeTaxPrice,
                                                    Licensekey: field.licenseKey,
                                                    StartLimit: field.startLimit,
                                                    EndLimit: field.endLimit,
                                                }
                                            }),
                                            Email: loginState.loginInfo.email,
                                            PostCode: pageParam.productParam.postCode,
                                            PhoneNumber: pageParam.productParam.phoneNumber,
                                            Address: pageParam.productParam.address,
                                            CustomerName: pageParam.productParam.customerName,
                                            Biko: pageParam.productParam.biko,
                                            DeliveryPrice: 0,
                                            DeliverySpan: pageParam.deliverySpan,
                                            IsDelivery: pageParam.productParam.isDelivery,
                                            PaypalCapturesId: id,
                                            PaypalResponseId: details.id,
                                        }
                                        HttpPostData<ResponseParam>("/License/CommitNewLicense", params, setIsLoading)
                                            .then(response => {
                                                JumpPage("PurchaseComplete", { list: response.data.list } as PageParam, "", navigate);
                                            })
                                            .catch(e => {
                                                setErrorMessage("購入情報の登録時にエラーが発生しました。カスタマーサポートからお問い合わせください。");
                                            });
                                    });
                                }}
                                onCancel={
                                    (data, actions) => {
                                        
                                    }
                                }
                                onError={
                                    (err) => {
                                        
                                    }
                                }
                            />
                        }
                        <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                    </div>                    
                </div>
            </section>
        </>
    );
}

/**
 * 新規ライセンスの一覧を表示
 * @param prop
 */
const NewProductTable = (prop: ToPaymentConfirm) => {
    return (
        <>
            <section className={base.forPc} style={{ marginTop: "50px", marginBottom: "50px" }}>
                <table className={base.pcTable} style={{ width: "70%" }}>
                    <colgroup>
                        <col width="25%" />
                        <col width="45%" />
                        <col width="30%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>ライセンス数</th>
                            <th>有効期間</th>
                            <th>金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        {prop.purchaseParam.userLicenses.map((field, index) => {
                            return (
                                <tr key={index}>
                                    <td>{field.quantity}</td>
                                    <td>{field.limitSpanStr}</td>
                                    <td>{field.displayTotalNonTaxPrice}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <th>消費税</th>
                            <td>{prop.purchaseParam.displayTotalTaxPrice}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <th>合計(税込)</th>
                            <td>{prop.purchaseParam.displayTotalIncludeTaxPrice}</td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <section className={base.forSp} style={{ marginTop: "50px", marginBottom: "50px" }}>
                <table className={base.spTable} style={{ width: "100%" }}>
                    <colgroup>
                        <col width="20%" />
                        <col width="55%" />
                        <col width="25%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>ライセンス数</th>
                            <th>有効期間</th>
                            <th>金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        {prop.purchaseParam.userLicenses.map((field, index) => {
                            return (
                                <tr>
                                    <td>{field.quantity}</td>
                                    <td>{field.limitSpanStartStr}<br />～<br />{field.limitSpanEndStr}</td>
                                    <td>{field.displayTotalNonTaxPrice}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <th>消費税</th>
                            <td>{prop.purchaseParam.displayTotalTaxPrice}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <th>合計 （税込）</th>
                            <td>{prop.purchaseParam.displayTotalIncludeTaxPrice}</td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </>
    );
}


/**
 * 継続ライセンス
 * @param prop
 */
const ContinueProductTable = (prop: ToPaymentConfirm) => {
    return (
        <>
            <section className={base.forPc} style={{ marginTop: "50px", marginBottom: "50px" }}>
                <table className={base.pcTable} style={{ width: "80%" }}>
                    <thead>
                        <tr>
                            <th>ライセンスコード</th>
                            <th>延長期間</th>
                            <th>金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        {prop.purchaseParam.userLicenses.map((field, index) => {
                            return (
                                <tr key={index}>
                                    <td>{field.licenseKey}</td>
                                    <td>{field.limitSpanStr}</td>
                                    <td>{field.displayTotalNonTaxPrice}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <th>消費税</th>
                            <td>{prop.purchaseParam.displayTotalTaxPrice}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <th>合計（税込）</th>
                            <td>{prop.purchaseParam.displayTotalIncludeTaxPrice}</td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <section className={base.forSp}>
                <table className={base.spTable} style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>ライセンスコード</th>
                            <th>有効期間</th>
                            <th>金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        {prop.purchaseParam.userLicenses.map((field, index) => {
                            return (
                                <tr>
                                    <td>{field.licenseKey}</td>
                                    <td>{field.limitSpanStr}</td>
                                    <td>{field.displayTotalNonTaxPrice}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <th>消費税</th>
                            <td>{prop.purchaseParam.displayTotalTaxPrice}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <th>合計（税込）</th>
                            <td>{prop.purchaseParam.displayTotalIncludeTaxPrice}</td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </>
    );
}

/**
 * Pcケース一覧表示
 * @param prop
 */
const PcCaseTable = (prop: ToPaymentConfirm) => {
    return (
        <>
            <section className={base.forPc} style={{ marginTop: "50px", marginBottom: "50px" }}>
                <table className={base.pcTable} style={{ width: "80%" }}>
                <thead>
                    <tr>
                        <td>RPA端末用ケース<br />購入数</td>
                        <td>付属品（ClickerAce新規ライセンス）<br />有効期間</td>
                        <td>金額</td>
                    </tr>
                </thead>
                <tbody>
                    {prop.purchaseParam.userLicenses.map((field, index) => {
                        return (
                            <tr key={index}>
                                <td>{field.quantity}</td>
                                <td>{field.limitSpanStr}</td>
                                <td>{field.displayTotalNonTaxPrice}</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td></td>
                        <td>送料</td>
                        <td>{FormatNumber(NumberFormatType.Normal, 0)}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>消費税</td>
                        <td>{prop.purchaseParam.displayTotalTaxPrice}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>合計（税込）</td>
                        <td>{prop.purchaseParam.displayTotalIncludeTaxPrice}</td>
                    </tr>
                </tbody>
                </table>
            </section>
            <section className={base.forSp}>
                <table className={base.spTable} style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <td>RPA端末用ケース<br />購入数</td>
                            <td>付属品（ClickerAce新規ライセンス）<br />有効期間</td>
                            <td>金額</td>
                        </tr>
                    </thead>
                    <tbody>
                        {prop.purchaseParam.userLicenses.map((field, index) => {
                            return (
                                <tr key={index}>
                                    <td>{field.quantity}</td>
                                    <td>{field.limitSpanStr}</td>
                                    <td>{field.displayTotalNonTaxPrice}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td></td>
                            <td>送料</td>
                            <td>{FormatNumber(NumberFormatType.Normal, 0)}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>消費税</td>
                            <td>{prop.purchaseParam.displayTotalTaxPrice}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>合計（税込）</td>
                            <td>{prop.purchaseParam.displayTotalIncludeTaxPrice}</td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </>
    );
}

/**
 * 送付を行う場合のデータ一覧の表示
 * @param prop
 */
const DerivaryUserData = (prop: BuyProductParam) => {
    return (
        <>
            <Grid item xs={12}><TitleDiv title="発送先" contents="" /></Grid>
            <CenterGrid item xs={1}></CenterGrid>
            <CenterGrid item xs={2}>郵便番号</CenterGrid>
            <Grid item xs={9} sx={{ textAlign: "left" }} >{prop.postCode}</Grid>

            <CenterGrid item xs={1}></CenterGrid>
            <CenterGrid item xs={2}>住所</CenterGrid>
            <Grid item xs={9} sx={{ textAlign: "left" }}>{prop.address}</Grid>

            <Grid item xs={1}></Grid>
            <CenterGrid item xs={2}>名前</CenterGrid>
            <Grid item xs={9} sx={{ textAlign: "left" }}>{prop.customerName}</Grid>

            <Grid item xs={1}></Grid>
            <CenterGrid item xs={2}>電話番号</CenterGrid>
            <Grid item xs={9} sx={{ textAlign: "left" }}>{prop.phoneNumber}</Grid>

            <Grid item xs={1}></Grid>
            <CenterGrid item xs={2}>備考</CenterGrid>
            <Grid item xs={9} sx={{ textAlign: "left" }}>{prop.biko}</Grid>

        </>
    );
}